<template>
  <header id="site-header">
    <div class="content">
      <h1 class="title">
        <img :src="imgSrc" :alt="title" />
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      imgSrc: require(process.env.VUE_APP_LOGO)
    }
  }
}
</script>

<style lang="scss">
#site-header {
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  .title {
    font-size: 1rem;
    margin: 0;
    img {
      height: 30px;
      max-width: 265px;
    }
  }
}
</style>
